import { ReactNode, createContext } from "react";
import useCategoriaFinanceira, { CategoriaFinanceiraType, CreateCategoriaFinanceiraType, UpdateCategoriaFinanceiraType } from "./hooks/useCategoriaFinanceira";

interface CategoriaFinanceiraContextProviderProps {
    children: ReactNode;
}

export interface CategoriaFinanceiraContextData {
    getAllCategoriaFinanceiraPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
    ) => Promise<CategoriaFinanceiraType[] | null>;
    setCategoriaFinanceira: any;
    categoriaFinanceira: CategoriaFinanceiraType;
    setListCategoriaFinanceira: any;
    listCategoriaFinanceira: CategoriaFinanceiraType[];
    setInitialListCategoriaFinanceira: any;
    initialListCategoriaFinanceira: CategoriaFinanceiraType[];
    setCategoriaFinanceiraPageCount: any;
    categoriaFinanceiraPageCount: number;
    createCategoriaFinanceira: (createCategoriaFinanceiraType: CreateCategoriaFinanceiraType) => Promise<CreateCategoriaFinanceiraType | null>;
    updateCategoriaFinanceira: (updateCategoriaFinanceiraType: UpdateCategoriaFinanceiraType) => Promise<UpdateCategoriaFinanceiraType | null>;
    deleteCategoriaFinanceira: (id: number) => Promise<CategoriaFinanceiraType | null>;
    handleGetCategoriaFinanceiraByEmpresaId: (empresaId: number) => Promise<CategoriaFinanceiraType[] | null>;
    listCategoriaFinanceiraByEmpresa: CategoriaFinanceiraType[];
    setListCategoriaFinanceiraByEmpresa: any;
}

const initialState: CategoriaFinanceiraContextData = {
    getAllCategoriaFinanceiraPaged: async (
        pageNumber: number,
        pageSize: number,
        officeId?: number,
    ) => {
        return Promise.resolve(null);
    },
    setCategoriaFinanceira: () => { },
    categoriaFinanceira: {
        id: 0,
        name: "",
        empresaId: 0,
    },
    setListCategoriaFinanceira: () => {},
    listCategoriaFinanceira: [],
    setInitialListCategoriaFinanceira: () => {},
    initialListCategoriaFinanceira: [],
    setCategoriaFinanceiraPageCount: () => {},
    categoriaFinanceiraPageCount: 0,
    createCategoriaFinanceira: async (createCategoriaFinanceiraType: CreateCategoriaFinanceiraType) => {
        return Promise.resolve(null);
    },
    updateCategoriaFinanceira: async (updateCategoriaFinanceiraType: UpdateCategoriaFinanceiraType) => {
        return Promise.resolve(null);
    },
    deleteCategoriaFinanceira: async (id: number) => {
        return Promise.resolve(null);
    },
    handleGetCategoriaFinanceiraByEmpresaId: async (empresaId: number) => {
        return Promise.resolve(null);
    },
    listCategoriaFinanceiraByEmpresa: [],
    setListCategoriaFinanceiraByEmpresa: () => {},
};

export const CategoriaFinanceiraContext =
    createContext<CategoriaFinanceiraContextData>(initialState);

export default function CategoriaFinanceiraContextProvider({
    children,
}: CategoriaFinanceiraContextProviderProps) {
    const {
        getAllCategoriaFinanceiraPaged,
        createCategoriaFinanceira,
        updateCategoriaFinanceira,
        deleteCategoriaFinanceira,
        categoriaFinanceira,
        setCategoriaFinanceira,
        setListCategoriaFinanceira,
        listCategoriaFinanceira,
        initialListCategoriaFinanceira,
        setInitialListCategoriaFinanceira,
        setCategoriaFinanceiraPageCount,
        categoriaFinanceiraPageCount,
        handleGetCategoriaFinanceiraByEmpresaId,
        listCategoriaFinanceiraByEmpresa,
        setListCategoriaFinanceiraByEmpresa,
    } = useCategoriaFinanceira();

    return (
        <CategoriaFinanceiraContext.Provider
            value={{
                getAllCategoriaFinanceiraPaged,
                createCategoriaFinanceira,
                updateCategoriaFinanceira,
                deleteCategoriaFinanceira,
                categoriaFinanceira,
                setCategoriaFinanceira,
                setListCategoriaFinanceira,
                listCategoriaFinanceira,
                initialListCategoriaFinanceira,
                setInitialListCategoriaFinanceira,
                setCategoriaFinanceiraPageCount,
                categoriaFinanceiraPageCount,
                handleGetCategoriaFinanceiraByEmpresaId,
                listCategoriaFinanceiraByEmpresa,
                setListCategoriaFinanceiraByEmpresa,
            }}
        >
            {children}
        </CategoriaFinanceiraContext.Provider>
    );
}